/**
 * Macht aus einem Drive-Link eine Adresse, die ein `<img>` anzeigen kann.
 *
 * Warum: Bei `fertig` schreibt n8n (`7_... DEV`, Node "Statusdaten: fertig") `bildUrls` als
 * Links auf die Drive-SEITE (`/file/d/<ID>/view?usp=drivesdk`). Die liefern `text/html`, das
 * `<img>` scheitert und die Detailseite meldete "Bild n ist nicht mehr abrufbar". Dieselbe
 * Datei als `/thumbnail?id=<ID>&sz=w800` liefert ohne Anmeldung `image/jpeg` (gemessen am
 * 2026-10-01: 200, 67 KB). Freigabeseite und n8n-Vorschau nutzen genau diese Form.
 *
 * Alles, was nicht eindeutig ein Drive-Dateilink ist, bleibt unveraendert: Generator-Links,
 * schon fertige Vorschaubilder und kaputte Adressen. Geparst wird mit `URL`, damit ein
 * fremder Host mit passendem Pfad nicht umgeschrieben wird.
 */
const DRIVE_HOST = 'drive.google.com';
const DRIVE_ID = /^[A-Za-z0-9_-]+$/;
const DATEI_PFAD = /^\/file\/d\/([^/]+)(?:\/(?:view|preview))?\/?$/;

export function alsBildquelle(url: string): string {
  let adresse: URL;
  try {
    adresse = new URL(url);
  } catch {
    return url;
  }
  if (adresse.protocol !== 'https:' || adresse.hostname !== DRIVE_HOST) return url;

  let id: string | null = null;
  const datei = DATEI_PFAD.exec(adresse.pathname);
  if (datei) id = datei[1] ?? null;
  else if (adresse.pathname === '/open' || adresse.pathname === '/uc') {
    id = adresse.searchParams.get('id');
  }

  if (id === null || !DRIVE_ID.test(id)) return url;
  return `https://${DRIVE_HOST}/thumbnail?id=${id}&sz=w800`;
}
